import { StyledGrid } from "./styled";
import { IGridProps } from "./types";

const Grid = ({children, ...props}: IGridProps)=>(
    <StyledGrid {...props}>
        {children}
    </StyledGrid>
)

export {Grid}